import { render, staticRenderFns } from "./ButtonTransfer.vue?vue&type=template&id=a55dcc06&"
import script from "./ButtonTransfer.vue?vue&type=script&lang=ts&"
export * from "./ButtonTransfer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports